var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgThreeAsset = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 15,
    viewBox: "0 0 24 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.5 5.08333V9.91667C14.5 10.0769 14.4342 10.2306 14.3169 10.3439C14.1997 10.4572 14.0408 10.5208 13.875 10.5208H12.625V4.47917H13.875C14.0408 4.47917 14.1997 4.54282 14.3169 4.65612C14.4342 4.76943 14.5 4.9231 14.5 5.08333ZM23.25 0.854167V14.1458L18.25 9.3125V13.5417C18.25 13.8621 18.1183 14.1695 17.8839 14.3961C17.6495 14.6227 17.3315 14.75 17 14.75H2C1.66848 14.75 1.35054 14.6227 1.11612 14.3961C0.881696 14.1695 0.75 13.8621 0.75 13.5417V1.45833C0.75 1.13786 0.881696 0.830519 1.11612 0.603913C1.35054 0.377306 1.66848 0.25 2 0.25H17C17.3315 0.25 17.6495 0.377306 17.8839 0.603913C18.1183 0.830519 18.25 1.13786 18.25 1.45833V5.6875L23.25 0.854167ZM8.875 4.47917C8.875 3.99846 8.67746 3.53745 8.32583 3.19754C7.97419 2.85763 7.49728 2.66667 7 2.66667H2.625V4.47917H7V6.59375H3.875V8.40625H7V10.5208H2.625V12.3333H7C7.49728 12.3333 7.97419 12.1424 8.32583 11.8025C8.67746 11.4626 8.875 11.0015 8.875 10.5208V4.47917ZM16.375 4.47917C16.375 3.99846 16.1775 3.53745 15.8258 3.19754C15.4742 2.85763 14.9973 2.66667 14.5 2.66667H10.75V12.3333H14.5C14.9973 12.3333 15.4742 12.1424 15.8258 11.8025C16.1775 11.4626 16.375 11.0015 16.375 10.5208",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgThreeAsset);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/threeAsset.0d9680c9c66dcce02d9c62e5b8e00b3d.svg";